export enum ProjectUsageRange {
    OneHour = '1h',
    OneDay = '1d',
}